import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function NationalRailStation(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fill: "#E91640",
    d: "M5.636 11.797H0v2.161h5.683l5.932 3.375h3.922L9.6 13.958h10.395v-2.161H9.553l5.142-2.927H20V6.709h-5.683L8.38 3.333H4.463l5.932 3.376H0v2.16h10.773l-5.137 2.928z"
  }));
}

export { NationalRailStation };
//# sourceMappingURL=NationalRailStation.js.map